import { render } from "./RemoveFilterButton.vue?vue&type=template&id=4b9e812d"
import script from "./RemoveFilterButton.vue?vue&type=script&lang=js"
export * from "./RemoveFilterButton.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__